import {
  faBookBlank,
  faDatabase,
  faFile,
  faFileContract,
  faGlobe,
  faQuoteLeft,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
  TaskMessageResponseSource,
  TaskMessageResponseSourceType,
} from '../../graphql/schema';
import FormattedMessage from '../base/FormattedMessage/formattedMessage';
import {
  faBook,
  faFileArchive,
  faFileLines,
  faPage,
} from '@fortawesome/pro-solid-svg-icons';

interface Props {
  sources?: TaskMessageResponseSource[] | null;
}

const MessageSources = ({ sources }: Props) => {
  return (
    <div className="flex-col flex group">
      <div className="p-5 space-y-5 flex-1 flex flex-col overflow-y-auto overflow-x-auto">
        {sources?.map((source) => {
          if (
            source.type === TaskMessageResponseSourceType.KNOWLEDGE_BASE_FILE
          ) {
            return (
              <div
                className="w-full space-y-1 block"
                key={`${source.url}-${source.title}`}
              >
                <div className="space-x-1 text-xs">
                  <FontAwesomeIcon icon={faDatabase} size="sm" />
                  <span>
                    Unternehmensdaten{source.fileId ? ', Quelle: ' : ''}
                    {source.fileId && (
                      <span>
                        "
                        {source.fileId.slice(
                          source.fileId.lastIndexOf('/') + 1,
                        )}
                        "
                        {source.pageNumber
                          ? `, Seite ${source.pageNumber}`
                          : ''}
                      </span>
                    )}
                  </span>
                </div>
                {source.title && (
                  <div className="space-y-1">
                    {source.title && (
                      <div className="font-semibold text-gray-900">
                        {source.title}
                      </div>
                    )}
                  </div>
                )}
                {source.content && (
                  <div className="text-xs text-gray-500">
                    <FormattedMessage text={source.content} />
                  </div>
                )}
                <hr />
              </div>
            );
          }

          return (
            <a
              className="w-full space-y-1 block"
              key={`${source.url}-${source.title}`}
              href={source.url ?? ''}
              target="_blank"
            >
              <div className="space-x-1 text-xs">
                <FontAwesomeIcon icon={faGlobe} size="sm" />
                <span>Internetseite</span>
              </div>
              {source.title && (
                <div className="font-semibold">{source.title}</div>
              )}
              {source.content && (
                <div className="text-xs text-gray-500">
                  <FormattedMessage text={source.content} />
                </div>
              )}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default MessageSources;
